<template>
  <v-sheet :color="specialist.name && available ? 'rgba(255,255,255,0.2)' : 'deep-orange'" class="d-flex justify-space-between align-center mr-2 px-1 mb-1" rounded="xl">
    <p style="text-align: right; font-size: 12px;">
      <span v-if="specialist.name && available">
        {{ sname_initials(specialist.name) }}
      </span>
      <span v-else-if="!available" v-on:click="specialist_cant_work">
        {{ sname_initials(specialist.name) }}
      </span>
      <span v-else v-on:click="open_error_dialog">
        <v-icon :icon="['fas', 'triangle-exclamation']" /> ОШИБКА
      </span>
    </p>

    <v-btn :icon="true" v-on:click="delete_specialist"  size="x-small" density="compact" class="ml-2" flat variant="plain">
      <v-icon :icon="['fas', 'xmark']" />
    </v-btn>
  </v-sheet>
</template>

<script>

import { sname_initials } from "@/libs/utils";
import moment from "moment/moment";
import { Allerts } from "@/store/global/Allerts";
import { TokenGUIDStore } from "@/store/global/SessionStore";

export default {
  name: "MiniUser__WP_Module",
  props: ['specialist', 'day'],
  data() {
    return {

    }
  },
  methods: {
    sname_initials,
    delete_specialist: function () {
      this.$emit('delete')
    },
    specialist_cant_work: function () {
      Allerts().warn(
          "ВНИМАНИЕ",
          `Специалист ${this.specialist.name} не может работать в выбранный день! Скорректируйте состав бригады!`,
          '#fd9e22',
          'triangle-exclamation'
      )
    },
    open_error_dialog: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/user/info`
      let config = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify({
          guid: this.specialist.guid
        })
      }

      await fetch(url, config)
          .then(async response => {
            if (!response.ok) {
              throw `Ошибка получения данных пользователя`
            }
            return await response.json()
          })
          .then(async result => {
            if (result && result.response) {
              Allerts().warn(
                  result.data['Наименование'],
                  'КОНФЛИКТ ПОДРАЗДЕЛЕНИЙ!<br>ДАННЫЙ СОТРУДНИК НЕ ПРИНАДЛЕЖИТ ТЕКУЩЕМУ ПОДРАЗДЕЛЕНИЮ. ВОЗМОЖНО ВЫ ЗАБЫЛИ УКАЗАТЬ КОМАНДИРОВКУ!',
                  '#fd5622',
                  'triangle-exclamation'
              )
            }
          }).catch(err => {
            console.error(err)
          })
    },
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
    available() {
      if (this.specialist.name) {
        return this.specialist.days[moment(this.day.date).weekday()]
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped>


</style>
